import { Divider } from "components/atoms/Divider";
import Image from "next/image";

interface Props {
  image: string;
  title: string;
  className?: string;
}

export const ThemeCardImage = ({ image, title, className }: Props) => {
  return (
    <div tw="relative" className={className}>
      <Image
        src={image}
        width={222}
        height={107}
        layout="responsive"
        objectFit="cover"
        priority
      />
      <div tw="absolute inset-0 flex-center flex-col text-white">
        <span tw="font-normal text-xs tracking-[.5px] leading-3">
          相談ジャンル
        </span>
        <Divider tw="w-3 my-2" />
        <h5 tw="font-bold text-[27px] tracking-[1.13px]">{title}</h5>
      </div>
    </div>
  );
};
